




























import { Vue, Component, Prop, Model, Watch } from 'vue-property-decorator';

import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import SelectionBox from '@/componentsV2/molecules/Inputs/SelectionBox.vue';
import OnlineStoreIcon from '@/components/icons/OnlineStore.vue';
import InStoreIcon from '@/components/icons/InStore.vue';
import {
  BgByStatus,
  ColorByStatus
} from '@/components/molecules/CountryItem/CountryItem.vue';

import { IBusinessType } from '@/models/business';
import { EInternationalizationStatus } from '@/models/internationalization';

import InternationalizationService from '@/api/InternationalizationService';

type ListItem = {
  operation: IBusinessType;
  title: string;
  description?: string;
  isUndated?: boolean;
  icon: string;
};

@Component({
  components: {
    SelectionBox,
    OnlineStoreIcon,
    InStoreIcon,
    GhostButton
  }
})
export default class BusinessOperateSelect extends Vue {
  @Model('input', { type: String }) value?: string;

  @Prop() countryName?: string;
  @Prop() availableStatus?: EInternationalizationStatus;
  @Prop({ default: false }) hasError?: boolean;

  internationalizationService = new InternationalizationService();

  BgByStatus = BgByStatus;
  ColorByStatus = ColorByStatus;
  BusinessType = IBusinessType;

  loading = false;
  list: ListItem[] = [
    {
      operation: IBusinessType.ONLINE,
      title: 'Online Business',
      description: 'An e-commerce store',
      icon: 'OnlineStoreIcon'
    },
    {
      operation: IBusinessType.INSTORE,
      title: 'In-store Business',
      description: 'A physical store',
      icon: 'InStoreIcon'
    }
  ];
  form = {
    [IBusinessType.ONLINE]:
      this.value === IBusinessType.ONLINE || this.value === IBusinessType.BOTH,
    [IBusinessType.INSTORE]:
      this.value === IBusinessType.INSTORE || this.value === IBusinessType.BOTH
  };

  get transformedList() {
    const listByStatus: Record<EInternationalizationStatus, ListItem[]> = {
      [EInternationalizationStatus.FULL]: this.list,
      [EInternationalizationStatus.ONLINE_ONLY]: [...this.list]
        .map(item => ({
          ...item,
          isUndated: item.operation === IBusinessType.INSTORE
        }))
        .reverse(),
      [EInternationalizationStatus.UNDATED]: this.list.map(item => ({
        ...item,
        isUndated: true
      }))
    };

    return listByStatus[
      this.availableStatus || EInternationalizationStatus.FULL
    ];
  }

  get operationType() {
    if (Object.values(this.form).every(value => !value)) return '';

    if (Object.values(this.form).every(Boolean)) {
      return IBusinessType.BOTH;
    }

    const [type] = Object.entries(this.form).find(([_, value]) => value)!;

    return type;
  }

  @Watch('operationType')
  onChangeBusinessOperationType() {
    this.$emit('input', this.operationType);
  }
}
